import { axios } from 'lib'
import { useMutation } from 'react-query'
import { toast } from 'react-toastify'

type Params = {
  url: string
}

const confirmSignature = async (params: Params): Promise<any> => {
  return await axios.get('/autentique/signedPdf', {
    params
  })
}

export function useConfirmSignature() {
  return useMutation(confirmSignature, {
    onError: (error: unknown) => {
      console.error(error)
      toast.error('Não foi possível anexar o orçamento, anexe manualmente!')
    }
  })
}
